import { Component } from 'react'

class Background extends Component {


    render () {
        return (
            <div id="background-wrap"> 
          
            </div>
        )
    }
}

export default Background